import { useGamesStore } from '../../store';

export const useGetIsRecommendedGamesLoaded = (entityName: string) => {
  return useGamesStore((store) => store.recommendedGames[entityName]?.isLoaded);
};
